import Vue from 'vue'
import VueGtag from 'vue-gtag'
import VueGtm from '@gtm-support/vue2-gtm'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'
import router from '@shared/router'

let includes = []
if (process.env.VUE_APP_ENABLE_GOOGLE_ANALYTICS_WITH_ID !== 'false') {
  includes = [
    { id: process.env.VUE_APP_ENABLE_GOOGLE_ANALYTICS_WITH_ID }
  ]
}

if (process.env.VUE_APP_ENABLE_GOOGLE_ANALYTICS_V4_WITH_ID !== 'false') {
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_ENABLE_GOOGLE_ANALYTICS_V4_WITH_ID },
    includes
  }, router)
}

if (process.env.VUE_APP_ENABLE_GOOGLE_TAG_MANAGER_WITH_ID !== 'false') {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_ENABLE_GOOGLE_TAG_MANAGER_WITH_ID,
    enabled: true,
    vueRouter: router
  })
}

if (process.env.VUE_APP_ENABLE_FACEBOOK_PIXEL_WITH_ID !== 'false') {
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js'))

  Vue.use(VueFacebookPixel, { router })
  Vue.analytics.fbq.init(process.env.VUE_APP_ENABLE_FACEBOOK_PIXEL_WITH_ID)
}
